import { render, staticRenderFns } from "./EmployeeAvatar.vue?vue&type=template&id=64f55ae4&"
import script from "./EmployeeAvatar.vue?vue&type=script&lang=ts&"
export * from "./EmployeeAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeAvatar.vue?vue&type=style&index=0&id=64f55ae4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports